module.exports = __webpack_public_path__ + "img/hr-deepwater-green2.b45fe6d2.png";